import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=279f143e&"
import script from "./SurveyTable.vue?vue&type=script&lang=js&"
export * from "./SurveyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports